import React from "react";
import { useNavigate } from "react-router-dom";
import "./home-page.css";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";
import MarketingFooter from "./components/MarketingFooter";
export default function StreetFood() {
  const navigate = useNavigate();

  return (
    <div className="home-pro">

      <SEO
        title="Ordini QR per Street Food, Chioschi e Food Truck | QrMenu Italia"
        description="QrMenu Italia permette a street food, chioschi, food truck e locali veloci di ricevere ordini direttamente dal cellulare dei clienti tramite QR Code, con numero progressivo e invio immediato dell'ordine."
        canonical="https://qrmenu-italia.it/street-food"
        image="https://qrmenu-italia.it/og-pizzerie.jpg"
        keywords="ordini qr street food, menu qr street food, ordini qr code, menu digitale food truck, ordini chiosco, ordini food truck, menu digitale street food, qrmenu"
      />

      <MarketingNavbar />

      {/* HERO */}
      <section className="hp-hero">
        <div className="hp-hero-noise" />
        <div className="hp-hero-glow" />

        <div className="hp-hero-inner">
          <div className="hp-hero-eyebrow">
            <span className="hp-dot" />
            ORDINI QR PER STREET FOOD
          </div>

          <h1 className="hp-hero-h1">
            Più ordini,
            <span className="hp-hero-accent">
              meno fila alla cassa.
            </span>
          </h1>

          <p className="hp-hero-sub">
            Il cliente è già davanti al tuo locale: inquadra il QR Code,
            sceglie cosa ordinare dal cellulare e invia direttamente il suo ordine.
            Tu ricevi ordinazioni progressive e ordinate, senza rallentare la cassa
            nei momenti di maggiore affluenza.
          </p>

          <div className="hp-hero-pills">
            <span className="hp-pill">✦ Ordini direttamente dal QR Code</span>
            <span className="hp-pill">✦ Nessuna app da scaricare</span>
            <span className="hp-pill">✦ Numero ordine progressivo</span>
            <span className="hp-pill">✦ Ordini inviati direttamente in cucina</span>
            <span className="hp-pill">✦ Stampa automatica se configurata</span>
          </div>

          <div className="hp-hero-actions">
            <button
              className="hp-btn-demo"
              onClick={() => navigate("/demo")}
            >
              Prova Gratis 7 Giorni
              <span className="hp-btn-arrow">→</span>
            </button>

            <button
              className="hp-btn-primary"
              onClick={() => navigate("/contatti")}
            >
              Richiedi informazioni
            </button>
          </div>
        </div>

        <div className="hp-hero-mockup">
          <div className="hp-phone">
            <div className="hp-phone-notch" />

            <div className="hp-phone-screen">
              <div className="hp-screen-header">
                <div className="hp-screen-tag">
                  ORDINE N° 25
                </div>

                <div className="hp-screen-time">
                  21:05
                </div>
              </div>

              <div className="hp-screen-category active">
                Panini
              </div>

              <div className="hp-screen-category">
                Bevande
              </div>

              <div className="hp-screen-item">
                <div className="hp-screen-item-img" />

                <div className="hp-screen-item-info">
                  <div className="hp-screen-item-name">
                    Panino Special
                  </div>

                  <div className="hp-screen-item-price">
                    € 8,50
                  </div>
                </div>

                <div className="hp-screen-item-add">
                  +
                </div>
              </div>

              <div className="hp-screen-item">
                <div className="hp-screen-item-img alt" />

                <div className="hp-screen-item-info">
                  <div className="hp-screen-item-name">
                    Patatine
                  </div>

                  <div className="hp-screen-item-price">
                    € 4,00
                  </div>
                </div>

                <div className="hp-screen-item-add">
                  +
                </div>
              </div>

              <div className="hp-screen-ai">
                <span className="hp-screen-ai-dot" />
                Ordine 25 inviato • in preparazione
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEO CONTENT */}
      <section className="hp-problem">
        <div className="hp-problem-inner">
          <div className="hp-section-tag">
            Ordini QR per Street Food
          </div>

          <h2 className="hp-section-h2">
            Quando arrivano tanti clienti insieme, la cassa non deve diventare un collo di bottiglia
          </h2>

          <p className="hp-seo-text">
            Street food, chioschi, food truck, sagre ed eventi hanno spesso lo stesso problema:
            nei momenti di maggiore affluenza molte persone arrivano contemporaneamente
            e si crea una fila solo per comunicare cosa vogliono ordinare.
          </p>

          <p className="hp-seo-text">
            Con QrMenu il cliente può inquadrare il QR Code mentre è davanti al locale,
            consultare il menu dal proprio cellulare e inviare direttamente l'ordine,
            senza scaricare app e senza creare un account.
          </p>

          <p className="hp-seo-text">
            Ogni nuovo ordine riceve un numero progressivo e arriva in modo chiaro
            al personale. La cucina può visualizzarlo immediatamente e, se configurata,
            può partire anche la stampa automatica della comanda.
          </p>

          <p className="hp-seo-text">
            Il risultato è un flusso più ordinato: mentre stai preparando gli ordini
            già ricevuti, altri clienti possono scegliere e inviare autonomamente
            ciò che desiderano, senza bloccare il personale alla raccolta delle ordinazioni.
          </p>
        </div>
      </section>

      {/* FEATURES */}
      <section className="hp-features">
        <div className="hp-section-tag">
          Cosa cambia per il tuo Street Food
        </div>

        <h2 className="hp-section-h2">
          Il cliente ordina dal cellulare, tu continui a lavorare
        </h2>

        <div className="hp-features-grid">

          <div className="hp-feat-card">
            <h3 className="hp-feat-title">
              Meno fila alla cassa
            </h3>

            <p className="hp-feat-desc">
              I clienti possono iniziare a ordinare appena arrivano,
              senza aspettare il proprio turno solo per comunicare l'ordinazione.
            </p>
          </div>

          <div className="hp-feat-card">
            <h3 className="hp-feat-title">
              Più ordini nelle ore di punta
            </h3>

            <p className="hp-feat-desc">
              Mentre il personale prepara un ordine, altri clienti possono
              già scegliere i prodotti e inviare il proprio dal cellulare.
            </p>
          </div>

          <div className="hp-feat-card hp-feat-card--featured">
            <h3 className="hp-feat-title">
              Ordini progressivi e ordinati
            </h3>

            <p className="hp-feat-desc">
              Ogni cliente riceve automaticamente un numero progressivo,
              rendendo più semplice riconoscere, preparare e consegnare gli ordini.
            </p>
          </div>

          <div className="hp-feat-card">
            <h3 className="hp-feat-title">
              Meno errori nelle ordinazioni
            </h3>

            <p className="hp-feat-desc">
              Il cliente seleziona direttamente prodotti, quantità e richieste,
              evitando incomprensioni durante i momenti più affollati.
            </p>
          </div>

          <div className="hp-feat-card">
            <h3 className="hp-feat-title">
              Cucina e stampa comande
            </h3>

            <p className="hp-feat-desc">
              Gli ordini possono arrivare direttamente in cucina e,
              se configurata, essere stampati automaticamente con QrPrint.
            </p>
          </div>

          <div className="hp-feat-card">
            <h3 className="hp-feat-title">
              Nessuna app per il cliente
            </h3>

            <p className="hp-feat-desc">
              Basta inquadrare il QR Code con il cellulare per vedere il menu
              e inviare l'ordine, senza registrazioni e senza installare nulla.
            </p>
          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="hp-final">
        <div className="hp-final-noise" />

        <div className="hp-final-inner">
          <h2 className="hp-final-h2">
            Meno tempo a prendere ordini. Più tempo per prepararli.
          </h2>

          <p className="hp-final-sub">
            Scopri come QrMenu può aiutare il tuo street food a gestire
            più facilmente le ordinazioni nei momenti di maggiore affluenza.
          </p>

          <button
            className="hp-btn-primary hp-btn-xl"
            onClick={() => navigate("/demo")}
          >
            Prova Gratis 7 Giorni
            <span className="hp-btn-arrow">→</span>
          </button>
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}